import React from 'react';
import { footerLinks } from '../data/content';
export function Footer() {
  return <footer className="w-full border-t border-white/10 bg-navy-dark px-5 py-14" data-id="element-93" data-mp="3gezc50oadkzk">
      <div className="mx-auto max-w-5xl text-center" data-id="element-94" data-mp="3gh3rcermy6f5">
        <p className="font-display text-xl font-black uppercase tracking-tight text-white" data-id="element-95" data-mp="32ovzn1f7l5nb">
          <span aria-hidden="true" data-id="element-96" data-mp="36qhh702ou83u">🎨 </span>Arte Pronta
        </p>
        <p className="mx-auto mt-3 max-w-md text-xs leading-relaxed text-white/55" data-id="element-97" data-mp="3ufa3s5xf73ls">
          Il sistema definitivo per docenti di arte che amano il loro tempo e il
          loro lavoro.
        </p>
        <nav aria-label="Footer" data-id="element-98" data-mp="3lem127dh8po7">
          <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-3 text-xs font-semibold text-white/65" data-id="element-99" data-mp="3ldap3k9vobm0">
            {footerLinks.map(link => <li key={link} data-id="element-100" data-mp="29z6ss7ftibds">
                <a href="#offerta" className="transition-colors hover:text-ochre" data-id="element-101" data-mp="29yxcxcohlklt">
                  {link}
                </a>
              </li>)}
          </ul>
        </nav>
        <p className="mx-auto mt-7 max-w-2xl text-[11px] leading-relaxed text-white/40" data-id="element-102" data-mp="3l9k292unj58j">
          © 2026 Arte Pronta — Tutti i diritti riservati.
        </p>
      </div>
    </footer>;
}